import React from 'react';
import { Avatar, Text } from '@carnica/ui-kit';
import { cnBem } from '@carnica/utils';
import styles from "./styles.pcss";
var cnAccount = cnBem('account-container', styles);
export var Account = function Account(_ref) {
  var number = _ref.number,
    nickname = _ref.nickname,
    avatar = _ref.avatar;
  var title = nickname || number;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    "data-t-id": "components-Account"
  }, /*#__PURE__*/React.createElement(Avatar, {
    image: avatar
  })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Text, {
    className: cnAccount(null, ['title']),
    lineHeight: 20,
    size: "xs"
  }, title), nickname && /*#__PURE__*/React.createElement(Text, {
    color: "tertiary",
    lineHeight: 20,
    size: "xs"
  }, number)));
};